import * as React from 'react';
import {
  DimensionValue,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import { useTheme } from 'react-native-paper';

import {
  bc,
  height,
  margin,
  mt,
  opacity,
  padding,
  rounded,
  width,
} from '../../style-utils';

export interface PanelLayoutProps {
  children: React.ReactNode;
  padding?: number;
  marginTop?: number;
  backgroundColor?: string;
  width?: DimensionValue;
  opacityBackground?: number;
  height?: DimensionValue;
  style?: StyleProp<ViewStyle>;
}

// TODO: convert to styled-component
export const PanelLayout = ({
  children,
  padding: padd = 40,
  backgroundColor,
  opacityBackground = 1,
  marginTop,
  height: heightPanel,
  width: widthPanel,
  style,
}: PanelLayoutProps) => {
  const { colors } = useTheme();
  return (
    <View
      style={[
        padding(padd),
        heightPanel ? height(heightPanel) : null,
        widthPanel ? width(widthPanel) : null,
        marginTop ? mt(marginTop) : null,
        style,
      ]}
    >
      {children}
      <View
        style={[
          bc(backgroundColor || colors.white),
          opacity(opacityBackground),
          height('100%'),
          width('100%'),
          margin(-padd),
          rounded(14),
          styles.background,
        ]}
      />
    </View>
  );
};
const styles = StyleSheet.create({
  background: { zIndex: -1, position: 'absolute' },
});
